import Screen from './screen';
import template from './templates/chat.html';
import { ElementRenderer } from '../../renderer/elementRenderer';
import { IframeExtension } from './extensions/iframeExtension';
import { resizeContentHeight } from '../../utils/resizeContentHeight';
import { LoadingElement } from './loadingElement';
import { TrackingNotice } from '../../customNotice/botNotice/trackingNotice';
import { AddressCheckExtension } from './extensions/addressCheck/addressCheckExtension';
import { ConfigurationManager } from '../../utils/configurationManager';
import { LoginExtension } from './extensions/tweetylogin/loginExtension';
import { InvoiceElement } from '../../renderer/invoiceElement';
export class ChatScreen extends Screen {
    constructor(uic) {
        super("chat", uic);
        // true if chat alert footer is visible
        this.alertVisible = false;
        /**
        * Adds an user message to the active chat window content container
        *
        * @param {*} userInput html formatted string that the user typed into the chatInputTextArea
        */
        this.appendUserTextToChatbox = (userInput) => {
            if (userInput) {
                this.currentUserForMessageElement = 'client';
                // Append user text to chatboxkp
                let lastUserMessageElement = $(userInput);
                // we want to scroll the user message into view
                this.wasLastMessageVisible = true;
                this.assumeUserReadMessage = false;
                this.lastMessageFromUser = true;
                setTimeout(() => {
                    // after 10 seconds we assume that the immediate messages after the user messages were read and we scroll to new messages
                    this.assumeUserReadMessage = true;
                }, 10000);
                lastUserMessageElement.appendTo(this.elements['chatWindowContent']);
                this.elements['chatWindowContent'].show();
                this.latestMessageElement = lastUserMessageElement.get(0);
                this.elements['chatInputTextArea'].get(0).value = '';
                // Reset char counter
                $('.js-textarea-current').text(this.elements['chatInputTextArea'].get(0).value.length);
                $(".cbot-quickreplies").remove();
                // removes quickreply container if quickreply was only message
                this.removeQuickreplies();
                this.disableCarouselButtonsBeforeUserInput();
                this.deactivateExtensionsOnUsermessage();
            }
        };
        this.resizeContent = () => {
            resizeContentHeight(this.elements['widgetWindow'], this.elements['chatWindowContentContainer']);
        };
        /**
        * Scroll an element into the view of the widget
        *
        * @param element to scroll into the view / optional
        */
        this.scrollIntoView = (element) => {
            let scrollToElement = element;
            if (!element) {
                scrollToElement = this.latestMessageElement;
            }
            if (scrollToElement && !this.assumeUserReadMessage) {
                scrollToElement.scrollIntoView();
                let container = this.elements['chatWindowContentContainer'][0];
                if (container.scrollTop < container.scrollHeight - container.clientHeight) {
                    container.scrollTop -= 15;
                }
            }
            else {
                this.scrollToBottom();
            }
        };
        /**
         * method to scroll content window to bottom
         * either instantly or via timeout
         *
         * @param timeout delay until scroll to bottom in ms
         */
        this.scrollToBottom = (timeout) => {
            let self = this;
            let fn = () => {
                let el = self.elements['chatWindowContentContainer'][0];
                el.scrollTop = el.scrollHeight - el.clientHeight;
            };
            if (timeout) {
                setTimeout(fn, timeout);
            }
            else {
                fn();
            }
        };
        /**
         * Removes all quickreplies but the last one
         */
        this.removeQuickreplies = () => {
            $('#chatWindow_content .cbot-bot .cbot-bot__messages div').not('div:last').filter('.cbot-quickreplies').remove();
            $('.cbot-bot').children('.cbot-bot__content').has('.cbot-bot__messages:empty').parent().remove();
        };
        /**
        * Function removes a typing div
        */
        this.hideTyping = () => {
            this.isShowingTyping = false;
            $('.cbot-bot-typing-wrapper').remove();
        };
        /**
        * Function creates a typing div and appends it to the chatwindow
        *
        * @param agent avatar who is writing
        */
        this.showTyping = (agent) => {
            if (!this.isShowingTyping) {
                this.isShowingTyping = true;
                let renderer = new ElementRenderer(this.uic.configuration);
                renderer.setUserImage(agent);
                let typing = renderer.addTyping();
                this.elements['chatWindowContent'].append(typing);
            }
        };
        /**
        * Returns true if the user is able to see the last message
        *
        * @returns true if last rendered message is visible for the user
        */
        this.isLastMessageVisible = () => {
            let scrollHeight = this.elements['chatWindowContentContainer'].get(0).scrollHeight;
            let scrollTop = this.elements['chatWindowContentContainer'].scrollTop();
            let height = this.elements['chatWindowContentContainer'].height();
            return (scrollTop + height >= scrollHeight - 30);
        };
        /**
         * Hide input and show alert message
         * @param {*} text Text that should be shown in warning
         */
        this.showAlert = (text) => {
            this.hideMainInput();
            this.elements['chatAlertText'].html(text);
            this.elements['chatAlert'].show();
            this.alertVisible = true;
        };
        /**
         * Hide alert message and show input
         */
        this.hideAlert = () => {
            this.elements['chatAlert'].hide();
            this.alertVisible = false;
            this.showMainInput();
        };
        /**
         * Shows a overlay that separates bot conversation from agent conversation
         */
        this.showBotConversationOverlay = () => {
            this.elements['chatWindowContentBotOverlay'].css("visibility", "visible");
            this.elements['chatWindowContentTag'].show();
        };
        /**
         * Hide a overlay that separates bot conversation from agent conversation
         */
        this.hideBotConversationOverlay = () => {
            this.elements['chatWindowContentBotOverlay'].css("visibility", "hidden");
            this.elements['chatWindowContentTag'].hide();
        };
        /**
        * Sets the maximum length of the message the user is able to send
        * @param {*} len Maximum text length as int
        */
        this.setMaxMessageLength = (len) => {
            if (len) {
                this.elements['maxUserInputContentLengthDisplay'].show();
                this.elements['maxUserInputContentLengthDisplay'].text('/' + len.toString());
                document.getElementById('chatInputTextArea').setAttribute('maxlength', len.toString());
            }
            else {
                this.elements['maxUserInputContentLengthDisplay'].hide();
                document.getElementById('chatInputTextArea').setAttribute('maxlength', "524288");
            }
        };
        this.trackLinks = (dataset) => {
            if (dataset.gacategory && dataset.galabel && dataset.gaaction) {
                this.uic.widget.track(dataset.gacategory, dataset.gaaction, dataset.galabel);
                let trackingNotice = new TrackingNotice(dataset.gacategory, dataset.gaaction, dataset.galabel);
                this.uic.widget.sendCustomNotice(trackingNotice);
            }
        };
        this.sendButtonEnabled = true;
        this.openOnMessageReceived = this.uic.configuration.openOnMessageReceived;
        this.latestMessageElement = undefined;
        this.assumeUserReadMessage = false;
        this.elements = {};
    }
    show(options) {
        if (this.uic.configuration.enableBanner && this.uic.widget.getStateMachine().mode != 'autoOpen' && (this.uic.widget.getStateMachine().botConnected || this.uic.widget.getStateMachine().botWasConnected)) {
            //do something) {
            if (!this.uic.widget.getStateMachine().tracked.mainTeaserView) {
                this.uic.widget.getStateMachine().tracked.mainTeaserView = true;
                this.uic.widget.track("chat", "view", "chat_screen_teaser");
            }
            this.elements['banner'].show();
        }
        else {
            this.elements['banner'].hide();
        }
        this.elements['completeChatwindow'].show();
        this.showMainInput();
        if (!this.uic.isMobile()) {
            this.elements['chatInputTextArea'].focus();
        }
        else {
            this.elements['chatInputTextArea'].blur();
        }
        if (this.uic.widget.getStateMachine().getScreenProperties(this.name) &&
            this.uic.widget.getStateMachine().getScreenProperties(this.name).showAddressCheck) {
            this.activateExtension("addressCheck");
        }
        this.elements['loader'].hide();
        this.resizeContent();
        this.scrollIntoView();
        this.stopLoadingAnimation();
    }
    hide() {
        this.elements['completeChatwindow'].hide();
    }
    /**
 * Appends the reponse from the chatbot in the chat window
 * @param {*} response rendered bot response
 */
    appendTextToChatbox(response, element, singleMessage, user) {
        if (!element) {
            element = this.elements['chatWindowContent'];
        }
        else {
            this.elements['chatWindowContent'] = element;
        }
        // Add text to chatbox
        if (!!response) {
            this.hideTyping();
            element.show();
            this.wasLastMessageVisible = this.isLastMessageVisible();
            let newElement = $(response);
            if (singleMessage) {
                if (this.currentUserForMessageElement !== user) {
                    this.currentUserForMessageElement = user;
                    if (user === 'bot' || user === 'agent') {
                        let renderer = new ElementRenderer(this.uic.configuration);
                        renderer.setUserImage(user);
                        let container = $(renderer.getNewUserMessageContainer());
                        container.appendTo(element);
                        this.currentMessageElement = renderer.getCurrentMessageContainer();
                    }
                    else {
                        this.currentMessageElement = element;
                    }
                }
                newElement.appendTo(this.currentMessageElement);
            }
            else {
                newElement.appendTo(element);
            }
            if (this.lastMessageFromUser) {
                this.lastMessageFromUser = false;
                this.latestMessageElement = newElement.get(0);
                setTimeout(() => {
                    this.scrollIntoView();
                }, 200);
            }
            if (!this.uic.isMobile()) {
                this.elements['chatInputTextArea'].focus();
            }
            else {
                this.elements['chatInputTextArea'].blur();
            }
            setTimeout(() => {
                if (!this.isLastMessageVisible()) {
                    this.showUnreadMessagesNotification();
                }
                if (this.wasLastMessageVisible) {
                    this.scrollIntoView();
                }
            }, 200);
            if (this.openOnMessageReceived) {
                this.uic.toggleChatWindowVisibility(true);
            }
            this.disableCarouselButtonsBeforeUserInput();
            this.removeQuickreplies();
            this.uic.stickyManager.messageReceived();
        }
    }
    /**
     * Shows a notification element that indicates that there are new unread messages
     */
    showUnreadMessagesNotification() {
        this.elements['unreadMessagesNotification'].removeClass('cbot-fade-out-unread');
        this.elements['unreadMessagesNotification'].show();
    }
    /**
     * Hides a notification element that indicates that there are new unread messages
     */
    hideUnreadMessagesNotification() {
        this.elements['unreadMessagesNotification'].hide();
    }
    /**
    * Do not allow user input
    */
    disableInput() {
        $('.cbot-chatInput__textarea')[0].disabled = true;
        this.sendButtonEnabled = false;
    }
    /**
     * Allow user input
     */
    enableInput() {
        $('.cbot-chatInput__textarea')[0].disabled = false;
        this.sendButtonEnabled = true;
    }
    /**
     * Shows upload icon for files
     */
    showUploadIcon() {
        this.elements['documentUploadIcon'].show();
    }
    /**
     * Hides upload icon for files
     */
    hideUploadIcon() {
        this.elements['documentUploadIcon'].hide();
    }
    setUploadAccept(string) {
        this.elements['documentUploadInputStaple'].attr('accept', string);
    }
    resizeEvent() {
        this.resizeContent();
        if (this.wasLastMessageVisible) {
            this.scrollIntoView();
        }
    }
    bootstrapScreen(chatWindowElement) {
        chatWindowElement.append(template);
        // Complete content inside chat window
        this.elements['widgetWindow'] = $('#chatbotWindow');
        this.elements['completeChatwindow'] = $('.js-complete-chatinput');
        this.elements['chatWindowMain'] = $('#chatWindow_main');
        this.elements['chatWindowMainHeader'] = $('#chatWindow_main_header');
        this.elements['header'] = $('#cbot-chatbotWindowHeader');
        this.elements['main_input'] = $('#cbot-chatbotWindowInput');
        this.elements['input'] = $('.cbot-chatWindow__inputfield');
        this.elements['sendButton'] = $('.cbot-chatInput__send');
        this.elements['chatInputTextArea'] = $('#chatInputTextArea');
        this.elements['banner'] = $('#cbot-chatbotWindowBanner');
        this.elements['banner-link'] = $('.js-cbot-banner-link');
        this.elements['banner-img'] = $('#cbot-banner-img');
        this.elements['banner-text'] = $('#cbot-banner-text');
        // Unread messages
        this.elements['unreadMessagesNotification'] = $('#chatWindow_content_unread');
        this.elements['chatWindowContentContainer'] = $('#chatWindow_content');
        this.elements['chatWindowContent'] = $('#chatWindow_content_bot');
        this.elements['chatWindowContentAgent'] = $('#chatWindow_content_agent');
        this.elements['chatWindowContentBot'] = $('#chatWindow_content_bot');
        this.elements['chatWindowContentTag'] = $('#chatWindow_content_tag');
        this.elements['chatWindowContentBotOverlay'] = $('#chatWindow_content_overlay');
        this.elements['maxUserInputContentLengthDisplay'] = $('#maxMessageLengthSpan');
        // Alert
        this.elements['chatAlert'] = $('.cbot-alert');
        this.elements['chatAlertText'] = $('.cbot-alert__content');
        this.elements['chatAlert'].hide();
        this.elements['documentUploadIcon'] = $('.cbot-chatInput__input-upload');
        this.elements['documentUploadInputStaple'] = $('#cbot-file-input');
        this.elements['loader'] = new LoadingElement(this.elements['completeChatwindow'], "chat");
        this.elements['loader'].addContentSpaceClass();
        if (this.uic.configuration.links) {
            this.elements['banner-link'].attr('href', this.uic.configuration.links.bannerLink);
        }
        this.elements['banner-link'].on('click', $.proxy(function (e) {
            this.uic.widget.track("chat", "click", "chat_screen_teaser");
        }, this));
        // -----------------------------------------------------------------------------
        //                         DYNAMICALLY RESIZE CONTENT
        // -----------------------------------------------------------------------------
        $('.cbot-chatbotWindow').onload = this.resizeContent();
        // remove notification if last message is seen
        this.elements['chatWindowContentContainer'].scroll(() => {
            if (this.elements['unreadMessagesNotification'].is(':visible') && this.isLastMessageVisible()) {
                this.elements['unreadMessagesNotification'].addClass('cbot-fade-out-unread');
            }
            this.wasLastMessageVisible = this.isLastMessageVisible();
        });
        this.elements['unreadMessagesNotification'].on('click', () => {
            this.scrollToBottom();
        });
        // Options for the observer (which mutations to observe)
        const config = { attributes: false, childList: true, subtree: true };
        // Callback function to execute when mutations are observed
        const callback = (mutationsList, observer) => {
            if (this.wasLastMessageVisible) {
                this.scrollIntoView();
            }
            mutationsList.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    const invoiceElement = InvoiceElement.getInvoiceElement(node);
                    if (invoiceElement) {
                        new InvoiceElement(this.uic.widget, invoiceElement);
                    }
                });
            });
        };
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        observer.observe(document.getElementById('chatWindow_content_bot'), config);
        observer.observe(document.getElementById('chatWindow_content_agent'), config);
        // Later, you can stop observing
        // observer.disconnect();
        // -----------------------------------------------------------------------------
        //                             HANDLE USER INPUT
        // -----------------------------------------------------------------------------
        // Counter for current chat length
        this.elements['chatInputTextArea'].get(0).addEventListener('input', () => {
            $('.js-textarea-current').text(this.elements['chatInputTextArea'].get(0).value.length);
            this.uic.widget.intObj.sendTyping();
        });
        // Accepting message with Enter
        $('.js-chatinput textarea').keypress($.proxy(function (e) {
            let code = (e.keyCode ? e.keyCode : e.which);
            if (code == 13) {
                e.preventDefault();
                let userText = $('.js-chatinput textarea').val().trim();
                if (!!userText) {
                    this.uic.widget.sendUserMessage(userText);
                }
            }
        }, this));
        // -----------------------------------------------------------------------------
        //                             SEND MESSAGE WITH PRESS ON SEND BUTTON
        // -----------------------------------------------------------------------------
        this.elements['sendButton'].on('click', $.proxy(function (e) {
            if (this.sendButtonEnabled) {
                // KARA-2041
                let userText = $('.js-chatinput textarea').val().trim();
                if (!!userText) {
                    this.uic.widget.sendUserMessage(userText);
                }
                $('.js-chatinput textarea').focus();
            }
        }, this));
        // -----------------------------------------------------------------------------
        //                             QUICK REPLY BUTTONS
        // -----------------------------------------------------------------------------
        this.elements['chatWindowContent'].on('click', '.jsClickable', $.proxy(function (e) {
            e.stopPropagation();
            // Get Textback Value to Send to Bot
            let quickReplyTextback = e.target.dataset.textback;
            this.uic.widget.sendUserMessage(quickReplyTextback, e.target.innerText);
            let quickReplyButtonsToHide = ".quickreplies_" + e.target.dataset.messageclass;
            $(quickReplyButtonsToHide).toggleClass('cbot-quickreplies--hidden');
            this.trackLinks(e.target.dataset);
        }, this));
        // -----------------------------------------------------------------------------
        //                      BUTTONS WITH EXTERNAL TARGET
        // -----------------------------------------------------------------------------
        this.elements['chatWindowContentContainer'].on('click', '.jsClickableWithExternalTarget', $.proxy(function (e) {
            // Get Textback Value to Send to Bot
            let quickReplyTextback = e.target.dataset.textback;
            if (quickReplyTextback) {
                this.uic.widget.sendUserMessage(quickReplyTextback, e.target.innerText);
            }
            let url = e.target.dataset.url;
            let urlTarget = e.target.dataset.urltarget;
            if (url && urlTarget) {
                window.open(url, urlTarget);
            }
            this.trackLinks(e.target.dataset);
        }, this));
        this.elements['chatWindowContentContainer'].on('click', '.jsClickableCommandButton', $.proxy(function (e) {
            let commandName = e.target.dataset.commandname;
            let commandOptions;
            if (e.target.dataset.commandoptions) {
                commandOptions = JSON.parse(decodeURI(e.target.dataset.commandoptions));
            }
            if (commandName) {
                this.uic.widget.sendCommand(commandName, commandOptions);
            }
            this.trackLinks(e.target.dataset);
        }, this));
        this.elements['chatWindowContentContainer'].on('click', '.jsClickableTracking', $.proxy(function (e) {
            this.trackLinks(e.currentTarget.dataset);
        }, this));
        // -----------------------------------------------------------------------------
        //                     FILE DOWNLOAD BUTTON
        // -----------------------------------------------------------------------------
        this.elements['chatWindowContentContainer'].on('click', '.cbot-download__buttons[data-action]', $.proxy(function (e) {
            let $target = $(e.target);
            let form = $(`
                <form method="POST" enctype="multipart/form-data" target="_blank" action="${$target.attr('data-action')}" style="display: none">
                <input name="alias"     value="${$target.attr('data-alias')}"     type="hidden">
                <input name="secureKey" value="${$target.attr('data-secureKey')}" type="hidden">
                <input name="userId"    value="${$target.attr('data-userId')}"    type="hidden">
                </form>`);
            $(document.body).append(form);
            form.submit();
        }, this));
        // -----------------------------------------------------------------------------
        //                             POSTBACK BUTTONS
        // -----------------------------------------------------------------------------
        // -----------------------------------------------------------------------------
        //                             CAROUSEL CALLBACK
        // -----------------------------------------------------------------------------
        let self = this;
        $.fn.initalizeGallery = function () {
            if (!this.hasClass('slick-initialized')) {
                this.slick({
                    infinite: false,
                    centerMode: true,
                    variableWidth: true,
                    accessibility: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: `<button class="cbot-gallery__button-back cbot-btn cbot-btn__primary"></button>`,
                    nextArrow: `<button class="cbot-gallery__button-next cbot-btn cbot-btn__primary"></button>`
                });
                this.on('afterChange', function (event, slick, currentSlide) {
                    if (currentSlide == 0) {
                        slick.$prevArrow.prop("disabled", true);
                    }
                    else {
                        slick.$prevArrow.prop("disabled", false);
                    }
                    if (currentSlide == slick.slideCount - 1) {
                        slick.$nextArrow.prop("disabled", true);
                    }
                    else {
                        slick.$nextArrow.prop("disabled", false);
                    }
                });
                let slick = this.slick('getSlick');
                if (slick.currentSlide == 0) {
                    slick.$prevArrow.prop("disabled", true);
                }
                else {
                    slick.$prevArrow.prop("disabled", false);
                }
                if (slick.currentSlide == slick.slideCount - 1) {
                    slick.$nextArrow.prop("disabled", true);
                }
                else {
                    slick.$nextArrow.prop("disabled", false);
                }
            }
        };
        // -----------------------------------------------------------------------------
        //                      UPLOAD HANDLER
        // -----------------------------------------------------------------------------
        this.elements['documentUploadInputStaple'].on('change', (ev) => {
            let xmsg = (message, file, limits) => {
                message = this.uic.configuration.i18n.hasOwnProperty(message) ? this.uic.configuration.i18n[message] : message;
                message = message.replace('%filename%', file && file.name ? file.name : '');
                message = message.replace('%filemb%', Math.round(((file && file.size ? file.size : 0) / (1024 * 1024)) * 100) / 100);
                message = message.replace('%upmaxmb%', Math.round((limits.uploadMax() / (1024 * 1024)) * 100) / 100);
                message = message.replace('%upmaxszmb%', Math.round((limits.uploadMaxSize() / (1024 * 1024)) * 100) / 100);
                message = message.replace('%upmaxcount%', limits.uploadCount());
                message = message.replace('%accept%', limits.accept());
                return message;
            };
            let fmsg = (message, file, limits) => {
                let msg = xmsg(message, file, limits);
                this.uic.createSystemMessage(msg);
            };
            let amsg = (message, file, limits) => {
                const prefix = this.uic.configuration.i18n['systemMessage2AgentPrefix'];
                message = this.uic.configuration.i18n.hasOwnProperty(message) ? this.uic.configuration.i18n[message] : message;
                // Send user message for agent, but do not display it in chat
                if (!this.uic.widget.getStateMachine().botConnected) {
                    this.uic.widget.sendUserMessage(xmsg(prefix + message, file, limits), "");
                }
            };
            // CHACA-1804
            let fchk = function (file, limits) {
                const re = new RegExp('(' + limits.accept().replace(/\./g, '\\.').replace(/[,;]/g, '|') + ')$');
                return file && file.name ? re.test(file.name.toLowerCase()) : false;
            };
            const files = ev.target.files;
            const limits = this.uic.widget.intObj.getFileLimits();
            const canUpload = limits.canUpload();
            if (!canUpload) {
                amsg('systemMessageFileUploadExceeded', undefined, limits);
                fmsg('systemMessageFileUploadExceeded', undefined, limits);
                this.showUploadIcon();
                return;
            }
            for (let i = 0; i < files.length; i++) {
                let file = files[i];
                if (!fchk(file, limits)) {
                    amsg('systemMessageFileInvalid1', file, limits);
                    fmsg('systemMessageFileInvalid1', file, limits);
                    fmsg('systemMessageFileInvalid2', file, limits);
                    continue;
                }
                if (!canUpload) {
                    this.showUploadIcon();
                    amsg('systemMessageFileUploadExceeded', file, limits);
                    fmsg('systemMessageFileUploadExceeded', file, limits);
                    continue;
                }
                if (file.size >= limits.uploadMax()) {
                    amsg('systemMessageFileSizeError', file, limits);
                    fmsg('systemMessageFileSizeError', file, limits);
                    continue;
                }
                if (file.size >= limits.uploadMaxSize()) {
                    amsg('systemMessageFileMaxSizeError', file, limits);
                    fmsg('systemMessageFileMaxSizeError', file, limits);
                    continue;
                }
                limits.uploaded(file.size);
                // file upload muss asynchron laufen
                new function (file) {
                    fmsg('systemMessageFileUploadStart', file, limits);
                    amsg('systemMessage2AgentFileUploadStarted', file, limits);
                    let formData = new FormData();
                    formData.append('file', file);
                    formData.append('alias', self.uic.widget.sessionData.alias);
                    formData.append('userId', self.uic.widget.sessionData.userId);
                    formData.append('secureKey', self.uic.widget.sessionData.secureKey);
                    // https://stackoverflow.com/questions/5587973/javascript-upload-file
                    // https://developer.mozilla.org/de/docs/Web/API/WindowOrWorkerGlobalScope/fetch
                    let req = new XMLHttpRequest();
                    req.open("POST", self.uic.widget.intObj.getFileUpload(self.uic.widget.sessionData.sessionID));
                    req.onreadystatechange = function () {
                        if (req.readyState === 4) {
                            let ok = false;
                            if (200 == req.status) {
                                try {
                                    let response = JSON.parse(req.responseText);
                                    if (response.hasOwnProperty("userData") && response.userData["file-id"]) {
                                        ok = true;
                                    }
                                }
                                catch (e) { }
                            }
                            fmsg('systemMessageFileUpload' + (ok ? 'Success' : 'Failure'), file, limits);
                        }
                    };
                    req.send(formData);
                }(file);
            }
            // reset input field so the next click on the same file succeeds
            $(ev.target).val('');
        });
        if (this.uic.widgetConsole) {
            this.uic.widgetConsole.addDebugInfoButtonHandler();
        }
        if (ConfigurationManager.getValueIfExists(this.uic.configuration, 'chatScreen.disableInputPlaceholder') ||
            this.uic.widget.getStateMachine().getScreenProperties(this.name).hideInputPlaceholder) {
            this.elements['chatInputTextArea'].removeAttr('placeholder');
        }
        else if (ConfigurationManager.getValueIfExists(this.uic.configuration, 'i18n.chatScreenInputPlaceholder')) {
            this.elements['chatInputTextArea'].attr("placeholder", ConfigurationManager.getValueIfExists(this.uic.configuration, 'i18n.chatScreenInputPlaceholder'));
        }
        this.bindHidePlaceholderOnChange();
        this.extensions.push(new IframeExtension(this));
        this.extensions.push(new AddressCheckExtension(this));
        this.extensions.push(new LoginExtension(this));
    }
    /**
     * Shows a loading spinner instead of the input field
     */
    loadingAnimation() {
        this.hideMainInput();
        this.elements['loader'].show();
    }
    /**
     * Shows a loading spinner instead of the input field
     */
    stopLoadingAnimation() {
        this.showMainInput();
        this.elements['loader'].hide();
    }
    /**
     * Show main input field if possible
     */
    showMainInput() {
        if (!this.alertVisible) {
            this.elements['main_input'].show();
        }
    }
    /**
     * Hide main input field if possible
     */
    hideMainInput() {
        this.elements['main_input'].hide();
    }
    /**
     * Shows the placeholder for the chat input field
     */
    showInputPlaceholder() {
        this.uic.widget.getStateMachine().setScreenProperty(this.name, 'hideInputPlaceholder', false);
        this.bindHidePlaceholderOnChange();
        if (ConfigurationManager.getValueIfExists(this.uic.configuration, 'i18n.chatScreenInputPlaceholder')) {
            this.elements['chatInputTextArea'].attr("placeholder", ConfigurationManager.getValueIfExists(this.uic.configuration, 'i18n.chatScreenInputPlaceholder'));
        }
    }
    resetContent() {
        this.hideBotConversationOverlay();
        this.elements['chatWindowContentAgent'].html('');
        this.elements['chatWindowContentAgent'].hide();
        this.elements['chatWindowContentBot'].children().not('#chatWindow_content_overlay').not('#chatWindow_content_tag').remove();
        this.elements['chatWindowContentBot'].hide();
        this.currentUserForMessageElement = undefined;
        this.currentMessageElement = undefined;
    }
    /**
     * Disables all carousel button that are shown before a user input
     */
    disableCarouselButtonsBeforeUserInput() {
        $(".cbot-user").prevAll("*").find(".cbot-galleryItem__button").prop('disabled', true);
    }
    bindHidePlaceholderOnChange() {
        this.elements['chatInputTextArea'].one('change keyup paste', () => {
            this.uic.widget.getStateMachine().setScreenProperty(this.name, 'hideInputPlaceholder', true);
            this.elements['chatInputTextArea'].removeAttr('placeholder');
        });
    }
    deactivateExtensionsOnUsermessage() {
        this.deactivateExtension('login');
        this.deactivateExtension('addressCheck');
    }
}
